import { mapValues } from 'lodash';

import { FetchListPayload } from '../actions/fetchList';

import createResource, { OptionalResource } from './createResource';
import { MessageTemplate } from './types';

const messageTemplatesResource = createResource<MessageTemplate>({
  key: 'messageTemplates',
  url: '/messageTemplates',
});

const customActions = {
  fetchList: (payload: OptionalResource<FetchListPayload<MessageTemplate>>) =>
    messageTemplatesResource.fetchList({
      ...payload,
      meta: {
        normalize: (data: any) => ({
          entities: {
            [messageTemplatesResource.key]: mapValues(data, (value: string, id: string) => ({
              id,
              value,
            })),
          },
          result: [],
        }),
        ...payload.meta,
      },
    }),
  fetchLanguages: (payload?: FetchListPayload<any>) =>
    messageTemplatesResource.fetchList({
      url: `${messageTemplatesResource.url}/languages`,
      ...payload,
    }),
};

export default {
  ...messageTemplatesResource,
  ...customActions,
};
